// Domain
import { CustomerDocumentsRepository } from '../../../domain/repositories/customer-documents-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CustomerDocumentsDummyRepository implements CustomerDocumentsRepository {
  request_update_ine(): Promise<void> {
    return Promise.resolve();
  }
}
